// SMART DEMO — Anadolu Sepeti asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 cheese + 4 olive-oil + 4 honey + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Anadolu Sepeti" tamamen kurgu demo markadır.

export const ANADOLU_SEPETI_ASSET_ROOT = "/demo-presets/localproducts/anadolu-sepeti";

export interface AnadoluSepetiManifest {
  logo: string;
  cheese: string[];
  oliveOil: string[];
  honey: string[];
  videos: string[];
}

export const ANADOLU_SEPETI_MANIFEST: AnadoluSepetiManifest = {
  logo: `${ANADOLU_SEPETI_ASSET_ROOT}/logo/logo.webp`,
  cheese: [
    `${ANADOLU_SEPETI_ASSET_ROOT}/cheese/01.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/cheese/02.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/cheese/03.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/cheese/04.webp`,
  ],
  oliveOil: [
    `${ANADOLU_SEPETI_ASSET_ROOT}/olive-oil/01.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/olive-oil/02.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/olive-oil/03.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/olive-oil/04.webp`,
  ],
  honey: [
    `${ANADOLU_SEPETI_ASSET_ROOT}/honey/01.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/honey/02.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/honey/03.webp`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/honey/04.webp`,
  ],
  videos: [
    `${ANADOLU_SEPETI_ASSET_ROOT}/videos/01.mp4`,
    `${ANADOLU_SEPETI_ASSET_ROOT}/videos/02.mp4`,
  ],
};